import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { Navigate } from 'react-router-dom'
import './Login.css'

function Login() {
  const { login, register, isAuthenticated, loading, error } = useAuth()
  const [isLoginMode, setIsLoginMode] = useState(true)
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    displayName: ''
  })
  const [formError, setFormError] = useState(null)

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
    setFormError(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setFormError(null)

    try {
      if (isLoginMode) {
        await login(formData.email, formData.password)
      } else {
        if (!formData.displayName.trim()) {
          setFormError('El nombre es requerido')
          return
        }
        await register(formData.email, formData.password, formData.displayName)
      }
    } catch (err) {
      // Error is handled in AuthContext
    }
  }

  const toggleMode = () => {
    setIsLoginMode(!isLoginMode)
    setFormError(null)
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-hero">
          <div className="login-logo">🎬</div>
          <h1 className="login-title">Pedrazo Movie Tracker</h1>
          <p className="login-subtitle">
            Tu diario personal de películas. Registra lo que ves, puntúa y comparte con amigos.
          </p>
        </div>

        <div className="login-card">
          <h2 className="login-card-title">
            {isLoginMode ? 'Iniciar sesión' : 'Crear cuenta'}
          </h2>

          <form className="login-form" onSubmit={handleSubmit}>
            {!isLoginMode && (
              <div className="form-group">
                <label htmlFor="displayName">Nombre</label>
                <input
                  type="text"
                  id="displayName"
                  name="displayName"
                  className="input"
                  placeholder="Tu nombre"
                  value={formData.displayName}
                  onChange={handleChange}
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                className="input"
                placeholder="tu@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                className="input"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
                minLength={6}
              />
            </div>

            {(error || formError) && (
              <div className="login-error">
                {formError || error}
              </div>
            )}

            <button 
              type="submit"
              className="btn btn-primary btn-lg login-submit"
              disabled={loading}
            >
              {loading ? 'Cargando...' : (isLoginMode ? 'Iniciar sesión' : 'Crear cuenta')}
            </button>
          </form>

          <div className="login-toggle">
            <span className="login-toggle-text">
              {isLoginMode ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'}
            </span>
            <button 
              type="button" 
              className="login-toggle-btn"
              onClick={toggleMode}
            >
              {isLoginMode ? 'Regístrate' : 'Inicia sesión'}
            </button>
          </div>
        </div>

        <div className="login-features">
          <div className="feature-item">
            <span className="feature-icon">📝</span>
            <span className="feature-text">Registra películas</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">⭐</span>
            <span className="feature-text">Puntúa y comenta</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">📊</span>
            <span className="feature-text">Ve tus estadísticas</span>
          </div>
          <div className="feature-item">
            <span className="feature-icon">🔗</span>
            <span className="feature-text">Comparte tu historial</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
